module.exports = __webpack_public_path__ + "static/media/22555722_1629547617120423_7248160673412425487_o.d5d1a8f8.jpg";